import type { TextOption } from "../../../types/Menu";
import Text from "../../text/Text";

const TextSelectValue = (props: Pick<TextOption<null>, "label">) => (
  <Text
    as="span"
    truncate
    text={props.label}
    class="text-base-medium text-primary select-none group-disabled:text-disabled"
  />
);

export default TextSelectValue;
